import { memo, type ReactNode } from 'react';
import { Flex, IconButton } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { getPlanPageThemeColors } from 'redux/ThemeSlice';

import { DriverPanelCloseIcon } from '../icons/DriverPanelFigmaIcons';

import DriverPanelViewToggle, { DriverPanelViewMode } from './DriverPanelViewToggle';

interface Properties {
  showViewToggle?: boolean;
  viewMode?: DriverPanelViewMode;
  onViewModeChange?: (mode: DriverPanelViewMode) => void;
  onClose: () => void;
  trailing?: ReactNode;
}

const DriverPanelHeader = ({
  showViewToggle = false,
  viewMode = 'property',
  onViewModeChange,
  onClose,
  trailing,
}: Properties) => {
  const themeColors = useSelector(getPlanPageThemeColors);

  return (
    <Flex alignItems='center' justifyContent='space-between' w='100%' gap={3} flexShrink={0}>
      {showViewToggle && onViewModeChange ? (
        <DriverPanelViewToggle viewMode={viewMode} onChange={onViewModeChange} />
      ) : (
        <Flex flex='1' />
      )}

      {trailing}

      <IconButton
        aria-label='Close input panel'
        icon={<DriverPanelCloseIcon color={themeColors.textDark} />}
        size='sm'
        w='32px'
        minW='32px'
        h='32px'
        p='10px'
        display='inline-flex'
        alignItems='center'
        justifyContent='center'
        borderRadius='full'
        variant='outline'
        borderColor={themeColors.border}
        bg={themeColors.surface}
        _hover={{ bg: themeColors.activeBg, borderColor: themeColors.primary }}
        onClick={onClose}
      />
    </Flex>
  );
};

export default memo(DriverPanelHeader);
